import React from 'react';
import './Spinner.css';

/**
 * Spinner component props.
 */
interface SpinnerProps {
  size?: 'small' | 'medium' | 'large';
  color?: 'primary' | 'white' | 'gray';
  centered?: boolean;
}

/**
 * Reusable loading spinner component.
 */
const Spinner: React.FC<SpinnerProps> = ({
  size = 'medium',
  color = 'primary',
  centered = false,
}) => {
  const spinnerClass = [
    'spinner',
    `spinner-${size}`,
    `spinner-${color}`,
  ].join(' ');

  const spinner = <div className={spinnerClass} />;

  if (centered) {
    return <div className="spinner-container">{spinner}</div>;
  }

  return spinner;
};

export default Spinner;
